var _rect, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagUk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 41 25",
    width: "1em",
    height: "1em",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 24.079,
    rx: 5,
    fill: "#D8D8D8"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 25
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 24.079,
    rx: 5,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 23.876h40.933V0H0v23.876z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 0L24.58 8.633h2.828L40.933 1.06V0H40zM26.77 15.723l14.164 7.926v-1.584l-11.335-6.342h-2.83zM0 1.817l12.116 6.815h2.831L0 .232v1.585zM14.306 15.723L0 23.738v.138h2.585l14.552-8.153h-2.832z",
    fill: "#BD0034"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8 0v8.027L38.132 0H23.8zM3.197 0l14.275 8.027V0H3.197zM31.21 8.632h9.723V3.155L31.21 8.632zM31.21 15.723l9.723 5.419v-5.42H31.21zM4.007 23.876h13.465V16.33L4.007 23.877zM23.8 23.876h13.507L23.8 16.33v7.546zM0 15.723v5.662l10.06-5.662H0zM0 8.632h10.06L0 2.962v5.67z",
    fill: "#1A237B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.738 0v10.051H0v4.256h18.738v9.57h3.796v-9.57h18.4v-4.256h-18.4V.001h-3.796z",
    fill: "#BD0034"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUk);
export default __webpack_public_path__ + "static/media/flag_uk.c4a0ec175e764d3787f13bda48ab9791.svg";
export { ForwardRef as ReactComponent };